fragment ExternalMeetingForModalFragment on ExternalMeeting {
    id
    recordingUrl
    audioLog {
        href
        fileId
    }
    serviceType
}
